/**
 * Decrypt-reveal effect for the header text logo.
 * Scrambles characters, then locks each letter in random order.
 * On the homepage, waits for the strobe loader to finish first.
 */
(function () {
  var CHARSET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*_-+=<>?/\\|~';
  var SCRAMBLE_MS = 65;
  var REVEAL_GAP_MS = 220;
  var TAIL_MS = 400;

  function randomChar() {
    return CHARSET[Math.floor(Math.random() * CHARSET.length)];
  }

  function shuffle(list) {
    for (var i = list.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = list[i];
      list[i] = list[j];
      list[j] = tmp;
    }
    return list;
  }

  function buildOutput(target, settled) {
    var output = '';
    for (var i = 0; i < target.length; i++) {
      var char = target[i];
      if (char === ' ' || settled[i]) {
        output += char;
      } else {
        output += randomChar();
      }
    }
    return output;
  }

  function decrypt(el) {
    var target = el.getAttribute('data-decrypt-text') || el.textContent;
    var length = target.length;
    if (!length || el.hasAttribute('data-decrypt-done')) return;

    el.setAttribute('data-decrypt-done', 'true');
    el.removeAttribute('aria-hidden');

    var settled = new Array(length).fill(false);
    var revealOrder = [];

    for (var i = 0; i < length; i++) {
      if (target[i] !== ' ') revealOrder.push(i);
    }

    shuffle(revealOrder);
    el.textContent = buildOutput(target, settled);

    var scrambleTimer = setInterval(function () {
      el.textContent = buildOutput(target, settled);
    }, SCRAMBLE_MS);

    revealOrder.forEach(function (index, step) {
      setTimeout(function () {
        settled[index] = true;
        el.textContent = buildOutput(target, settled);

        if (step === revealOrder.length - 1) {
          setTimeout(function () {
            clearInterval(scrambleTimer);
            el.textContent = target;
          }, TAIL_MS);
        }
      }, (step + 1) * REVEAL_GAP_MS);
    });

    if (!revealOrder.length) {
      clearInterval(scrambleTimer);
      el.textContent = target;
    }
  }

  function runDecrypt() {
    document.querySelectorAll('[data-decrypt-text]').forEach(decrypt);
  }

  function init() {
    var loader = document.getElementById('site-loader');

    if (loader) {
      window.addEventListener('site-loader:done', runDecrypt, { once: true });
      return;
    }

    runDecrypt();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
